/**
 * Is a nickname free? Asked from the SIGN-UP form, before an account exists.
 *
 * Hits the one unauthenticated route on the user API. There is no token to
 * send at this point in the flow — that is the whole reason the route exists.
 *
 * ADVISORY: someone can claim the handle between this answer and the claim on
 * first sign-in, so a `true` is encouragement, never a reservation.
 *
 * Fails OPEN. A network blip or a 429 must not block sign-up over a check that
 * cannot bind anything anyway.
 */

export interface NicknameCheck {
  available: boolean;
  reason?: string;
  nickname?: string;
}

const USER_API = process.env.REACT_APP_USER_API_URL || '';

export const checkNicknameAvailable = async (nickname: string): Promise<NicknameCheck> => {
  const handle = nickname.trim();
  if (!handle || !USER_API) return { available: true };

  try {
    const response = await fetch(
      `${USER_API}/public/nickname/available?nickname=${encodeURIComponent(handle)}`,
    );
    if (!response.ok) return { available: true };
    return (await response.json()) as NicknameCheck;
  } catch {
    return { available: true };
  }
};
